import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const affectionWordList = [
  "ally",
  "appreciate",
  "bloom",
  "bond",
  "chocolate",
  "clan",
  "comfort",
  "comfort",
  "common",
  "community",
  "connect",
  "delight",
  "encourage",
  "faithful",
  "family",
  "flower",
  "gentle",
  "gentle",
  "glow",
  "heart",
  "hold",
  "honey",
  "join",
  "link",
  "mate",
  "mutual",
  "partner",
  "protect",
  "refuge",
  "safe",
  "silk",
  "soft",
  "soft",
  "strengthen",
  "sugar",
  "surprise",
  "sweet",
  "tender",
  "tender",
  "tie",
  "touch",
  "treasure",
  "treat",
  "trust",
  "unite",
  "warm",
  "welcome",
];

export const affectionCollection: WordCollection = createCollection(
  "affection",
  "Affection & Kinship",
  affectionWordList,
  {
    icon: "heart-outline",
    isWordlistViewable: true,
    startDate: new Date(new Date().getFullYear(), 1, 1), // February 1st
    endDate: new Date(new Date().getFullYear(), 1, 28), // February 28th
  },
);
